import { TLoadable, createUnloaded } from "../../../../sg-core";
import { ILocationAction } from "../actions/locationAction";
import ILocation, { IArea, IFacility } from '../../interfaces/ILocation'
import { itemsToMappedIdList, appendUniqueToLodableIdList } from '../../utils/item.helpers'

export const defaultLocationState: ILocationState = {
    locations: {},
    locationList: createUnloaded(),

    facilities: {},
    facilityList: createUnloaded(),

    areas: {},
    areaList: createUnloaded(),


};

export interface ILocationState {
    locations: { [key: string]: ILocation }
    locationList: TLoadable<number[]>;

    facilities: { [key: string]: IFacility }
    facilityList: TLoadable<number[]>;

    areas: { [key: string]: IArea }
    areaList: TLoadable<number[]>;
}

export default function LocationReducer(state = defaultLocationState, action: ILocationAction) {
    switch (action.type) {


        case "APPEND_TO_LOCATION_LIST": {
            const parsed = itemsToMappedIdList(action.payload.locations);
            return {
                ...state,
                locations: { ...state.locations, ...parsed.mapping },
                locationList: appendUniqueToLodableIdList(state.locationList, parsed.ids),
            };
        }

        case "APPEND_TO_FACILITY_LIST": {
            const parsed = itemsToMappedIdList(action.payload.facilities);
            return {
                ...state,
                facilities: { ...state.facilities, ...parsed.mapping },
                facilityList: appendUniqueToLodableIdList(state.facilityList, parsed.ids),
            };
        }

        case "APPEND_TO_AREA_LIST": {
            const parsed = itemsToMappedIdList(action.payload.areas);
            return {
                ...state,
                areas: { ...state.areas, ...parsed.mapping },
                areaList: appendUniqueToLodableIdList(state.areaList, parsed.ids),
            };
        }



        default: {
            return state;
        }
    }
}
